import * as React from "react";
import * as styles from "./Incrementor.module.scss";

export const Container: React.FC<any> = (props) => {
  return (
    <div
      className={`${styles.container} d-flex justify-content-between align-items-center`}
    >
      {props.children}
    </div>
  );
};

export const InputWrapper: React.FC<any> = (props) => {
  return <div className={styles.inputWrapper}>{props.children}</div>;
};

export const Counter: React.FC<any> = (props) => {
  return (
    <div
      className={`${styles.counter} ${props.class}`}
      onClick={props.onClick}
      onKeyPress={props.onKeyPress}
      style={props.style}
    >
      {props.children}
    </div>
  );
};
